import { NewEmployeeReportState } from '../interface/NewEmployeeReportInterface'

export default function (state: NewEmployeeReportState = {}, action) {
    let propertyName: string;

    switch (action.type) {
        case "OPEN_ZOOM":
            propertyName = "showZoomed";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "CLOSE_ZOOM":
            propertyName = "showZoomed";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_REPORT_LOADING":
            return action.payload;

        case "STATE_TEXT":
            propertyName = "state_text";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "STATE_TEXT2":
            propertyName = "state_text2";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_RELEASE":
            propertyName = "employeeRelease";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_PROFILE_INFO":
            propertyName = "EmployeeProfileInfo";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_NATIONAL_LOCATION":
            propertyName = "EmployeeNationalLocation";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_LOCATION":
            propertyName = "EmployeeLocation";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_COMPANY":
            propertyName = "EmployeeCompany";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_BOXPLOT":
            propertyName = "EmployeeBoxPlot";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_BARPLOT":
            propertyName = "EmployeeBarPlot";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;
        case "EMPLOYEE_METHODOLOGY":
            propertyName = "EmployeeMethodology";
            var newState = Object.assign({}, state);
            newState[propertyName] = action.payload;
            return newState;

        case "DOWNLOAD":
            return state;
        default:
            return state;
    }
}